(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $$ = (sel, scope = document) => [...scope.querySelectorAll(sel)];

  /* Annonce rotative */
  $$('[data-mc-announce]').forEach((bar) => {
    const items = $$('.mc-announce__item', bar);
    if (items.length < 2) return;
    let i = 0;
    const speed = Number(bar.dataset.speed || 3) * 1000;
    setInterval(() => {
      const cur = items[i];
      i = (i + 1) % items.length;
      const next = items[i];
      next.style.transition = 'none';
      next.classList.remove('is-out', 'is-active');
      void next.offsetWidth;
      next.style.transition = '';
      cur.classList.remove('is-active');
      cur.classList.add('is-out');
      next.classList.add('is-active');
    }, speed);
  });

  /* Slider générique (galerie, vidéos, avis) */
  const initSlider = (wrap) => {
    const track = wrap.querySelector('[data-mc-track]');
    if (!track) return;
    const slides = [...track.children];
    const prev = wrap.querySelector('[data-mc-prev]');
    const next = wrap.querySelector('[data-mc-next]');
    const dotsWrap = wrap.parentElement.querySelector('[data-mc-dots]');
    const thumbs = $$('[data-mc-thumb]', wrap);
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
    const index = () => Math.round(track.scrollLeft / Math.max(1, step()));
    const perView = () => Math.max(1, Math.round(track.clientWidth / Math.max(1, step())));
    const pages = () => Math.max(1, slides.length - perView() + 1);
    const go = (n) => track.scrollTo({ left: Math.max(0, Math.min(n, pages() - 1)) * step(), behavior: 'smooth' });

    let dots = [];
    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (let p = 0; p < pages(); p++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Aller à la diapositive ${p + 1}`);
        b.addEventListener('click', () => go(p));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    };
    const update = () => {
      const i = index();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= pages() - 1;
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    prev && prev.addEventListener('click', () => go(index() - 1));
    next && next.addEventListener('click', () => go(index() + 1));
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', () => { buildDots(); update(); });
    buildDots();
    update();

    const auto = Number(wrap.dataset.autoplay || 0);
    if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let paused = false;
      ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => wrap.addEventListener(ev, () => { paused = true; }, { passive: true }));
      ['pointerleave', 'focusout'].forEach((ev) => wrap.addEventListener(ev, () => { paused = false; }));
      setInterval(() => {
        if (paused || document.hidden) return;
        const i = index();
        go(i >= pages() - 1 ? 0 : i + 1);
      }, auto * 1000);
    }
  };
  $$('[data-mc-slider]').forEach(initSlider);

  /* Panier : rafraîchissement du tiroir + quantités (délégation) */
  const setCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  };
  const refreshDrawer = async () => {
    const res = await fetch(`${root}?section_id=cart-drawer`);
    if (!res.ok) return;
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const cur = document.getElementById('CartDrawer');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    const c = doc.querySelector('[data-cart-count]');
    if (c) setCount(c.textContent.trim());
  };
  const openDrawer = () => {
    const d = document.getElementById('CartDrawer');
    if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
  };
  document.addEventListener('click', async (e) => {
    const close = e.target.closest('#CartDrawer [data-close]');
    if (close) {
      document.getElementById('CartDrawer').close();
      return;
    }
    const q = e.target.closest('[data-mc-qty]');
    if (!q) return;
    e.preventDefault();
    q.disabled = true;
    try {
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: q.dataset.key, quantity: Number(q.dataset.mcQty) }),
      });
    } finally {
      await refreshDrawer();
    }
  });

  /* Ajout au panier fait par une app (Rapid Bundle...) : rafraîchit puis ouvre le tiroir */
  const isCartAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  let pendingAdd;
  const afterAdd = () => {
    clearTimeout(pendingAdd);
    pendingAdd = setTimeout(async () => {
      await refreshDrawer();
      openDrawer();
    }, 150);
  };
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    try {
      const url = args[0] instanceof Request ? args[0].url : args[0];
      if (res.ok && isCartAdd(url)) afterAdd();
    } catch (err) {}
    return res;
  };
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (isCartAdd(url)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) afterAdd();
      });
    }
    return nativeOpen.call(this, method, url, ...rest);
  };

  /* Formulaire produit : Rapid Bundle remplit les champs (quantité, propriétés _rapi...),
     puis on envoie en AJAX avec exactement les mêmes données pour ouvrir le tiroir au lieu de /cart */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    // form.id renverrait l'input name="id" : on teste l'attribut via matches()
    if (!(form instanceof HTMLFormElement) || !form.matches('#mc-product-form') || e.defaultPrevented) return;
    e.preventDefault();
    const btn = form.querySelector('[data-mc-main-add]');
    let msg = form.querySelector('.mc-atc__error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'mc-atc__error';
      msg.setAttribute('role', 'alert');
      msg.hidden = true;
      btn.insertAdjacentElement('beforebegin', msg);
    }
    msg.hidden = true;
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        msg.textContent = j.description || 'Impossible d’ajouter au panier pour le moment.';
        msg.hidden = false;
      }
    } catch (err) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* Guide des tailles */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-mc-open]');
    if (open) {
      const d = document.getElementById(open.dataset.mcOpen);
      if (d && d.showModal) d.showModal();
    }
    const close = e.target.closest('[data-mc-close]');
    if (close) close.closest('dialog').close();
    if (e.target.matches && e.target.matches('dialog.mc-modal')) e.target.close();
  });

  /* Barre d'achat collante */
  const sticky = document.querySelector('[data-mc-sticky]');
  const mainAdd = document.querySelector('[data-mc-main-add]');
  if (sticky && mainAdd) {
    document.body.classList.add('mc-has-sticky');
    const io = new IntersectionObserver(([en]) => {
      sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    });
    io.observe(mainAdd);
    sticky.querySelector('[data-mc-sticky-add]').addEventListener('click', () => mainAdd.click());
  }

  /* Retour en haut */
  const top = document.querySelector('[data-mc-top]');
  if (top) {
    const onScroll = () => top.classList.toggle('is-on', window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
})();